(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-returns-contact"]) return;
  try {
    
  var coll = document.getElementsByClassName('collapsible');
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener('click', function() {
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-header"]) return;
  try {
    
  $(function() {
    var $sporttab = $('.js-sports-tabs').herotabs({
      css: {
        active: 'is-active',
        navCurrent: 'is-active',
      },
      selectors: {
        tab: '.js-tab-panel',
        navItem: '.js-tab-nav-item',
        nav: '.js-tab-nav',
      }
    });
    var instance = $sporttab.data('herotabs');
    instance.nextTab();
  });

  } catch(e) { console.error(e); }
})();
})();
